import type { RenameRequest } from '@visualizer/types';
import { requireApp } from 'store/assertions';

const getApiClient = () => requireApp().apiClient;

export async function rename(newLabel: string, item: RenameRequest): Promise<void> {
    await getApiClient().patch(`geodatas/${item.id}`, { name: newLabel });
}
